import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Grid, Cell, Button,
} from '@hyphengroup/cag-components';
import { getImageUrl } from 'helpers/Utils';
import Comparable from './Comparable';

const Span = styled.span`
  font-family: ProximaNova;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.17;
  color: #156c9a;
  width: 100%;
`;

function Product({
  comparables,
  productName,
  image,
  ctaButton,
  trackCtaClick,
}) {
  // Just retrieve the first 2 comparables
  const [comp1, comp2] = comparables;
  const twoComparables = [comp1, comp2];
  return (
    <>
      <Grid dataSelectorType="upperProduct" columns="69px 111px 88px" padding="9px 8px">
        <Cell dataSelectorType="image">
          <img src={getImageUrl(image.url)} width="69px" alt="Product" />
        </Cell>
        <Cell dataSelectorType="title">
          <Span>{productName}</Span>
        </Cell>
        <Cell dataSelectorType="cta">
          <a onClick={() => trackCtaClick()} href={ctaButton.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <Button variant="primary" size="small" base="classic" fluid>
              {ctaButton.label}
            </Button>
          </a>
        </Cell>
      </Grid>
      <Grid dataSelectorType="lowerProduct" columns="1fr 1fr" gap="0px">
        {
          twoComparables.map((comparable, index) => (
            // eslint-disable-next-line
            <Comparable key={index} amount={comparable.prefix + comparable.displayValue + comparable.suffix} display={comparable.title.display} subValue={comparable.subValue} />
          ))
        }
      </Grid>
    </>
  );
}

Product.propTypes = {
  comparables: PropTypes.arrayOf(PropTypes.shape({})),
  productName: PropTypes.string,
  functional: PropTypes.shape({
    metaData: PropTypes.shape({
      urlAlias: PropTypes.string.isRequired,
    }),
  }),
  image: PropTypes.shape({
    url: PropTypes.string,
  }),
  ctaButton: PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string,
  }),
  trackCtaClick: PropTypes.func,
};

export default Product;
